export const shortcode = 'boughto_alloy_wheel_package_redirect';

import React, { useEffect } from 'react';
import { fetchRedirectUrl } from '../api.js';  // Your API utility

export default function WheelPackageRedirect(props = {}) {
    const { product_id: productId } = props;

    useEffect(() => {
        (async () => {
            try {
                const resp = await fetchRedirectUrl({ product_id: productId });
                if (resp && resp.url) {
                    window.location.replace(resp.url);
                } else {
                    console.error('No redirect URL returned:', resp);
                }
            } catch (err) {
                console.error('Failed to fetch redirect URL:', err);
            }
        })();
    }, [productId]);

    return (
        <div>
            Redirecting…
        </div>
    );
}
